<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [{num_cand:"U2FsdGVkX19XHcY+SvM0Da0MQV8J84n21uo8+uaPD6Q=",cpf:"U2FsdGVkX1+igaky4BsXP1mBKIS2Eh/5Nc6Fcs/5V6w="},
{num_cand:"U2FsdGVkX19/e3CWbdcl9ESKtEuEAuaCPccrSQnhIwM=",cpf:"U2FsdGVkX1+d03AiVffyBOdvmrwG4BnxabzK4aOVbEw="},
{num_cand:"U2FsdGVkX1/sdSMuhanfgkubjh+IEC+oQhEVyzldk4I=",cpf:"U2FsdGVkX19jf1POVTJtFd/M35xliQs3lkMaB6JFz/M="},
{num_cand:"U2FsdGVkX1+GQfbNP6VaNxGwTNp1hcKVzRwyAmiS+hY=",cpf:"U2FsdGVkX18Lr2g8wHfcu+eUxwP9G6Ns+7wDjZ3l1uY="},
{num_cand:"U2FsdGVkX19OHweUPxixvudeYA2KnQShatYRwyrzxPE=",cpf:"U2FsdGVkX19ikU7q1g3EYV8MQhauozLAtjhnRCb4vtg="},
{num_cand:"U2FsdGVkX184JLsLcqoMsaKXr08j0qEqkxq3gPN/6R0=",cpf:"U2FsdGVkX1+ZdUkM0POO9uDnPjiPc0lSGOWX4IdUb2U="},
{num_cand:"U2FsdGVkX19DybTNz4OA4J11sVPldzoc2eYIQ4jSjFQ=",cpf:"U2FsdGVkX188Q7CT0q+S8jKR6aV5eQtlJlRm7yUh3Vs="},
{num_cand:"U2FsdGVkX19edC3dSP0KYO+YeJjOC4VUvYdeiogufBo=",cpf:"U2FsdGVkX1//IhVouHUlYYKAOOTdFCC9DJTbYPTU2v8="},
{num_cand:"U2FsdGVkX18jV/nMTnVdIHl57a492okZCigPHcIpEC0=",cpf:"U2FsdGVkX1/zLb/pj6l7/RtGjNhC0MAFALCKAXw4+o8="},
{num_cand:"U2FsdGVkX1/B2Jf0ayRt7dGxQH499VByw1phRDOfvo0=",cpf:"U2FsdGVkX18KJZkzWpnKdj/IySu8C22NkWM39Xnf2WA="},
{num_cand:"U2FsdGVkX18M6bvhuk+yO0eg7+hq/PdXIsqWTN6jdPw=",cpf:"U2FsdGVkX18gTNDoehOhmBXWgHaZ5kRaAPPSXoVYWN8="},
{num_cand:"U2FsdGVkX1/AsOAYTzO1E9cQFHdO+KOiLZMguXJ881c=",cpf:"U2FsdGVkX187VT1FwKqou7st8kyAaMKk6jBgjmPRsjU="},
{num_cand:"U2FsdGVkX1/ubk4nZAE73lCM3qiqLqjX0I/CowIKsvw=",cpf:"U2FsdGVkX1/nLg6eiXQMERI5U55rIDCYt9GxjTI+h3o="},
{num_cand:"U2FsdGVkX199WnP2XtxPGxSCehUzbQZPF0A/ax4uc8Y=",cpf:"U2FsdGVkX196SoAUvxLYz84CgSQME7xpQRph0MMPHFw="},
{num_cand:"U2FsdGVkX1+bnJ/Mn1O78u1TR+eHw1aMvRBLesRc1hw=",cpf:"U2FsdGVkX1/CV6MeQX+vNHB0xNAMkoSzOTQBtZEkLYA="},
{num_cand:"U2FsdGVkX1/M/PNm7OvIJ/yk08ypYTdQvq5ZHrDmR+k=",cpf:"U2FsdGVkX18B36P6DeAVlTbElv352sz4P4uJWfq6X6E="},
{num_cand:"U2FsdGVkX1/7akfGuvEJh50AUaUJo5keOADxomdmgyU=",cpf:"U2FsdGVkX19S4MeQpoSAiS17LV+Ge6Xua6qpuXuuwRs="},
{num_cand:"U2FsdGVkX1+romLTwqlWHag2jkO2wqVM21LohSLQmUo=",cpf:"U2FsdGVkX19h8gBSgBGrdfn81KdC20MYSavJdrv4f8k="},
{num_cand:"U2FsdGVkX18676qeR0ktl1WW1Qjn7gCGm1PDaAWU2wA=",cpf:"U2FsdGVkX19GyFXO3fHQbyB+C8aja39hEm3mA/9TrS8="},
{num_cand:"U2FsdGVkX1+a2SvnoN1yLZX3Eo4LQeUUTl9MeUjvuTw=",cpf:"U2FsdGVkX1+r8aCx2CSA0CHbexdyyMVQtUAj/134KnM="},
{num_cand:"U2FsdGVkX1/+HBT4LY3qDg7It/cT/ym8I+TfCaHwP4o=",cpf:"U2FsdGVkX18l1qR/0aXXHhFI+t8AoZ+a0IyZ/ttUYs4="},
{num_cand:"U2FsdGVkX1/Wl/8PWBuLCCGjXMQ//qpTClmKEbJNJXg=",cpf:"U2FsdGVkX18sBAIz0cpENmTk9h//Afnz+N7Uwkrh7QY="},
{num_cand:"U2FsdGVkX1/v4JmZW0UOclEvMJCJ9BDanDJC8dODB7Q=",cpf:"U2FsdGVkX18eeR9u/JiAp8+47gNnwyJKC5rktF2wZXU="},
{num_cand:"U2FsdGVkX19XER0utBJXMmtYJi1VUhSbwjq10H2l+PU=",cpf:"U2FsdGVkX1+N4ccii3VHgM5t3XXrD7lPr2sdr9eJrns="},
{num_cand:"U2FsdGVkX19USjAWUR+uQyj//FDPHtWhf96WpOJndrk=",cpf:"U2FsdGVkX1+vfSERnpwdTFhiBAx6JscHSkMl4UXWh9o="},
{num_cand:"U2FsdGVkX1/rFjCCDPYAFc8H7qeARKqPr+9FN01vyMQ=",cpf:"U2FsdGVkX187rdI1sI/gqXJ+RPTcWGbLqtgtBMnWQhw="},
{num_cand:"U2FsdGVkX19Xtas718eAiCNao6hBXeyNMpJTzuXpQRU=",cpf:"U2FsdGVkX1+dRG/9Xzx5doum4MfkJ7H4JcQD498zw7E="},
{num_cand:"U2FsdGVkX18gSnPIjglVWdfjtPHVR4/nbBfb5vw3ubs=",cpf:"U2FsdGVkX19rh7fLuurW3OgKhi7LsE7jSwosVZ1ZV74="},
{num_cand:"U2FsdGVkX19hFY359DB7OQgApT3UkfhoCEj+FVNMZwI=",cpf:"U2FsdGVkX190hT5d39ZxHOo9satEeT6/85/s3dy0WJA="},
{num_cand:"U2FsdGVkX18d1+DMc8O9Wzav6psB/1fjBW7Ek9iu1/k=",cpf:"U2FsdGVkX1+m8JBdI0zxgDiL5kalU8iscSTcycPe/aU="},
{num_cand:"U2FsdGVkX185lANgfqgwRF0FoBIiJGn8SOVoEXg0YA0=",cpf:"U2FsdGVkX1+e98y7xVyy4CT4eZ7jxtw7U87Qs1UPR2U="},
{num_cand:"U2FsdGVkX1/JrPLqSkLDZ9Bt/a5PLnwecieEwIR4vHY=",cpf:"U2FsdGVkX1+EKxPuji9546RNGqhuVnMjwLqgare1sSQ="},
{num_cand:"U2FsdGVkX1/Y1hQf352SFVmkLNqP8veUAM7nt6XkNy0=",cpf:"U2FsdGVkX19C2UhWM/THrmglueAZTU8aN2ZvTCwQDy8="},
{num_cand:"U2FsdGVkX1+BhrGurP8Z58SGWoYcVdlDzyw7BJB0PVM=",cpf:"U2FsdGVkX1+S6myvSTXwledJ/FgpCZWCH3XihgaKT7Y="},
{num_cand:"U2FsdGVkX18H76ACI2kFfns/CuMHbC0zU5T6HvQX/A8=",cpf:"U2FsdGVkX19dQEGvaATcwBoZ0hYg/vpTL6JbJ0E58Ao="},
{num_cand:"U2FsdGVkX19gKUlzkogXBOrcfa+iAmvTlLwYV1VBV/Y=",cpf:"U2FsdGVkX1/q8sEbLbxrVV1eZLiYMSekoyamE9aJAoo="},
{num_cand:"U2FsdGVkX1/S9xgVjB2KbpryMgSVM3hFlRH2f0TStE8=",cpf:"U2FsdGVkX1+ORaBABFD72dv5YuxSEID3BqlAPj/eLf0="},
{num_cand:"U2FsdGVkX1/uZKgtuI8bRI6CoAAx3J1TJepTiD/sCzQ=",cpf:"U2FsdGVkX19grkXUxrQQGYbTKDN+ouYEBDBCAXT40wk="},
{num_cand:"U2FsdGVkX1+DGSg3RI6UJR8EhQpqgB9/qlBLflklsUc=",cpf:"U2FsdGVkX19qJwLs6kdgnnONwbWhOS/ELfcE6JIB0Fo="},
{num_cand:"U2FsdGVkX1+vN8rqh4JZY7t9z8kfP2wcWJT2GE+TwHo=",cpf:"U2FsdGVkX19LsE4NQnfrh9pCYisYbOKEtvI0JCUZUnQ="},
{num_cand:"U2FsdGVkX1/CEM0OHovKbzrjuyDwVNZ25l0g0l+bm3U=",cpf:"U2FsdGVkX19QPabVZIpknzd9DnULAOsfCRC61dLFQ20="},
{num_cand:"U2FsdGVkX19tdzdRYw3UDihE0TCDbiIh1yzXr9X4EsE=",cpf:"U2FsdGVkX19HpVoghflsee1HX0EESHJ/BgDToVebyKk="},
{num_cand:"U2FsdGVkX1+uXxsdYaPgOOAYA1x7fO7Texq/GE25ZGs=",cpf:"U2FsdGVkX1+FAzg1zDsplwaiLdW60dNrtOMT/MTH5DA="},
{num_cand:"U2FsdGVkX19bU/+6OK/8gkxl/GhtHlYiyNFNsHcMaa0=",cpf:"U2FsdGVkX19QWRg4P5/4qSi/U1wdCOMJY+lqlPxL8d8="},
{num_cand:"U2FsdGVkX18n4YJpBGK6+fNyPubTd9L/Ydv0VfFLl9E=",cpf:"U2FsdGVkX1/uW+jnlSq0V/QTNk4/oLzmyygHBBGTq/o="},
{num_cand:"U2FsdGVkX1/X5wzllQtW3OCN3BmBbRSLh+mWtGNSiZQ=",cpf:"U2FsdGVkX1/Grpbxg23XiD+9zRXtXkVEeFp6EfwZouM="},
{num_cand:"U2FsdGVkX199z+2FbwD878GyxJEgMoi/Toe/aCmvsyk=",cpf:"U2FsdGVkX1/5zuQPOIxIXo48diJvihaTCOdFzLueEWE="},
{num_cand:"U2FsdGVkX1+YMLHSeIzNCE1upVkg7T8wLxHiONXEduk=",cpf:"U2FsdGVkX1+ooLun+AzRLbFWWy1zW8cdzRtB3QWEsvQ="},
{num_cand:"U2FsdGVkX1/J9evNJ+isVbj+JK2JlcH0vxALh8/uBeo=",cpf:"U2FsdGVkX18nXJdCBhn/d+cYFAJWgZhVlw2CuM/pj5c="},
{num_cand:"U2FsdGVkX1/tbnysgMJ2Fqtuem3K3Lo4krgJVl9A3PA=",cpf:"U2FsdGVkX19iniSeicaMmu4uzgHh+wpKFZp4yjzkFZs="},
{num_cand:"U2FsdGVkX18AiHklbHJvhHjdUqFrLZsFdNmt13/n6hg=",cpf:"U2FsdGVkX1/l0a1I6UdWLA6X8ugy2jNtsbeB0lNf+kA="},
{num_cand:"U2FsdGVkX18Qs10gtszTSsW/oM1SHLk6jYXKZr8Etbo=",cpf:"U2FsdGVkX18CZ31p/7JCaHSqaLkpu61zgro4XqbQIgM="},
{num_cand:"U2FsdGVkX19BdJzdCVh9uHqF1bYydy1plEkkQTv6jyQ=",cpf:"U2FsdGVkX1/ThqJmk4msi/q3bzxpzlVUL8e2XKxYJYA="},
{num_cand:"U2FsdGVkX1/5xkB04W3yTYojFe6rRfUahAexJdUpjhw=",cpf:"U2FsdGVkX18V6ZD6aonbkkld4/Kepna2cmG0Fib7ZMk="},
{num_cand:"U2FsdGVkX19thDLeeOgJeWDdjT9m5g1gNcYXWKX/vtM=",cpf:"U2FsdGVkX194nQ/dp37RCQf3fnw14Jn9DBRP+hyEa0U="},
{num_cand:"U2FsdGVkX18mzog0Oy7JQWoD9Kbz7XCXW4U9iCYOF0U=",cpf:"U2FsdGVkX1+WBPMSW1B/AfAJ+PQobvM4AlH5eFjE9A8="},
{num_cand:"U2FsdGVkX1/Pm2mcTbYeU7hwLeGvK0iPamgjfN/wfuk=",cpf:"U2FsdGVkX1/DMc9PSAdPcJZoaaBPpD/XvHVNITfngHI="},
{num_cand:"U2FsdGVkX1/aLbBjVhiQJHptgGyjkaXRtxX5SYTmEHc=",cpf:"U2FsdGVkX1+h0rRkOyH/iJEs6sVvbiLrWN2BIrf/Ud8="},
{num_cand:"U2FsdGVkX1/Jw0uirnIHkbBbahD0u1GbUNMZZtLC/zs=",cpf:"U2FsdGVkX1/uu7LkvVsYfGy1El+3f+dyntKszFD+wUA="},
{num_cand:"U2FsdGVkX1+p+ggbjHBbOFrGHiMppzSpPSl+wkWDhDA=",cpf:"U2FsdGVkX18bdT0dzup5bxJrNQye9kwfWkLE7KzvBYQ="},
{num_cand:"U2FsdGVkX18oeJ/35S+7F0Fsqp9i7NXS+G7o5tUcwXA=",cpf:"U2FsdGVkX1/d7iM0HQX99PY9Ut6qYcNmWihnbOsoZ3I="},
{num_cand:"U2FsdGVkX19CZVEsn1gBnLq7ohk1IaB65wfSbVsESF0=",cpf:"U2FsdGVkX184B1FDFgTUIIOOTyKIbaMShx9BzdDxGCk="},
{num_cand:"U2FsdGVkX1960cdqVP9xwWmgEhPR3ItAaUNdrS8EwEc=",cpf:"U2FsdGVkX18T7N1A6/8zPpRf2cMtEgrLNtIQjzmibhM="},
{num_cand:"U2FsdGVkX19HLrHwpb7f9dpv35nZxN0+cK5BO74U/gU=",cpf:"U2FsdGVkX19USlmFOy61kdohSuGiH0dG+4rmcX2QnBM="},
{num_cand:"U2FsdGVkX1+AKBVEOQXUq3rrSXHd7uFksX83nniscrA=",cpf:"U2FsdGVkX1/mMX04F3JToZBHmONoIFNSsBfYSXDvVzY="},
{num_cand:"U2FsdGVkX187P4/CkTz2kUi1N+sNJhGuemv9w+EYA2E=",cpf:"U2FsdGVkX1/xcnPbcegj7lxzX3jvRTkKDj1DpgPfVBc="},
{num_cand:"U2FsdGVkX18jrifyo1couo7OlduILr3kHSKFdhoIbgM=",cpf:"U2FsdGVkX1/wvxNES1Axt+ALaxFguPv7rEoCf+6nRoo="},
{num_cand:"U2FsdGVkX1/2oVn2snTlFGEKgfhDMjsgyb6UNtgMmjo=",cpf:"U2FsdGVkX1+sXrQGQp7+4FLgchSHVitgvFfCdiL4lOM="},
{num_cand:"U2FsdGVkX19lg02lgEylMHk60umbqYsS1838S38eYt8=",cpf:"U2FsdGVkX1+tckyc24cf12baZ/0kiGvRPhWocGRzysg="},
{num_cand:"U2FsdGVkX1+NSiEQVQa63bs3Ur6Ughxj6f6Cd8/mg38=",cpf:"U2FsdGVkX1+6w5YN8CsvHJ/8EKc4GbwIjK/elGfxlrk="},
{num_cand:"U2FsdGVkX19a1QW47ZC4ZRD3qDTjkKlzB/IrsK2KQxY=",cpf:"U2FsdGVkX19R3+Lt+fbL6UaowhXq6KfZtbp3K/3OVjE="},
{num_cand:"U2FsdGVkX19+oJ3lkAeoOpreQkAYKG1ZAv7z/Ki7KY0=",cpf:"U2FsdGVkX1+qaYCLRS6flyeuVJlonqf8wvx9MlLgSXs="},
{num_cand:"U2FsdGVkX19CD2tklLJ21KyyHUfwcVhTYk0GkfNBYj0=",cpf:"U2FsdGVkX1+ZOo76UyQr4pyLq3x6lRurC6Zk94nqLA0="},
{num_cand:"U2FsdGVkX19u+OVp9NzJ4gKIM04FeiOjioCah8COcO8=",cpf:"U2FsdGVkX1+XjNVK8ILWagIaBYElqPthld1hwefrrRI="},
{num_cand:"U2FsdGVkX1+KfWAhzVLZUojHXg/M7+FdCO3GZinxDS8=",cpf:"U2FsdGVkX1++gpUWRbNFpvA0307hvclhbV6xntckpZs="},
{num_cand:"U2FsdGVkX1+Te5XWTCMzQkVIAEUtPqhgsgd8cf35qLA=",cpf:"U2FsdGVkX1/WJITvHpD8pj0xrjolxXhrVLAV9GHvX6w="},
{num_cand:"U2FsdGVkX1+HHswlGHz/7KTgJn41NEt54E4VIHW84Ug=",cpf:"U2FsdGVkX1+DT1lY/C2QUYYbUzeIXNJO99j0mhocCyY="},
{num_cand:"U2FsdGVkX19xxFUFz04oDg76bf0IBgEukNeVLJumoMY=",cpf:"U2FsdGVkX1+1mg16xdP85PMJ3+pbRAXx31RKVaqfy2I="},
{num_cand:"U2FsdGVkX18gSYizFVeZLXcpPW3r6xaFXsB932ddIXM=",cpf:"U2FsdGVkX1/zi/gat+6YLfP/VQjvT3ltip4ISFeA1N4="},
{num_cand:"U2FsdGVkX19jJ8Ub4F5xbP6RxZaBEGvepqjwO/+u2y4=",cpf:"U2FsdGVkX1/xwFWKuuQ6p82CbuoifUJMRM5rxoedbTY="},
{num_cand:"U2FsdGVkX18U1gqEBlyg/PsV2sNrtVtrrz10AyYUR3k=",cpf:"U2FsdGVkX1/Y7lUO1ncizjYk8nmGKI9XC4hKwdQ0S2U="},
{num_cand:"U2FsdGVkX19ZT3mLbBMw0LK8xFXImKPOVIjkEnl2izs=",cpf:"U2FsdGVkX1/aeftUYLanOHtglcpTiSD4MzV0GsZiks0="},
{num_cand:"U2FsdGVkX18GAAcjUS4r1UjHTp5DRZc0yBVsETJ4PhA=",cpf:"U2FsdGVkX1/gEnICK5WWG4cPs5sftEuvLkktzSLtmLE="},
{num_cand:"U2FsdGVkX19n0PQhVKj/qn8s3ugLeYXuhwGeeBDBa0Y=",cpf:"U2FsdGVkX1/Uf9m8FbdHdQjY7yQb4XTyF3BJhUeKPQ4="},
{num_cand:"U2FsdGVkX1/vt7HgzILhKAG6EXfBSsTXvWyCsddy29s=",cpf:"U2FsdGVkX1+rZoBqsc+bpPthVN9mhPylWEJTCWSK0tY="},
{num_cand:"U2FsdGVkX19EeSmvvapmew/jKJz7qMDaWQ+9anhENGs=",cpf:"U2FsdGVkX1/JCKxXRu4+Ib6+c7B8guD1nDXjWT3OMqA="},
{num_cand:"U2FsdGVkX1+YuE+nQe7dSSKYWiBL40Wh5P7deKvaq2c=",cpf:"U2FsdGVkX18QxOrJ/5PC+myGBeCFLpTL9s1yAcCBQVQ="},
{num_cand:"U2FsdGVkX1+ia3R2bFXRw/1avjrdhhk3AAAriCalEdo=",cpf:"U2FsdGVkX1+0qHPrLcV6zeiUatqEBqfUDLAnosybhkc="},
{num_cand:"U2FsdGVkX181hMKae1B1mzMjZsFjnNts1eVN1nq9lDk=",cpf:"U2FsdGVkX19tu1aox0FTHfx6V/D3yS5N8ZmyEe3zNmM="},
{num_cand:"U2FsdGVkX1+V3mJe3biqtp9T8SVubUeaqQ1MF5vJiF8=",cpf:"U2FsdGVkX1/E7BMDqNMgm8e9fXw3XlhU/kvWx1Dxxfg="},
{num_cand:"U2FsdGVkX1+EvoEqz7YZAPvJgXR52EbXU7JpZbes9xM=",cpf:"U2FsdGVkX1+yPHk0FeZ5a/YPQ3tkoSSWiRiifKQYSFE="},
{num_cand:"U2FsdGVkX1/rrC7Zf3TcxOvXNpRAT+xgXDflodAzpf0=",cpf:"U2FsdGVkX18xmCcoFjSijzhJAnmlD3Iyznnxy5p9lkQ="},
{num_cand:"U2FsdGVkX1/SsloFwrV0dFJyU4uHPO14EV/3Hl6uriM=",cpf:"U2FsdGVkX19XUpK5eeXLDeX2GjHjfNK4f4n1zIwb2Kg="},
{num_cand:"U2FsdGVkX19vnbnYuK0D5j7zy7fCYnk5hjBPb63KhNA=",cpf:"U2FsdGVkX19Q4fCdiS2p9Q26nRHnV7sdgTkHUuP3+gk="},
{num_cand:"U2FsdGVkX1/bH6l6Rbak3/3DbsfGMF1ei3Ur+tDZDoQ=",cpf:"U2FsdGVkX1+tUjI7GRvpSOlvh2s1PnPSW4gT7KCDWhg="},
{num_cand:"U2FsdGVkX19MW1iLIBzc6gQXOMRijmWPnfSpd9f2s2g=",cpf:"U2FsdGVkX1925NmsTeTthbf/8G+oQnNyVTFCwyFp+oo="},
{num_cand:"U2FsdGVkX18pWFMjU0V0ywsktfwPPaazulHFmr03j+Q=",cpf:"U2FsdGVkX18N3rrOiTE4K4iwY4JZlMhvCEVX5ihIN8o="},
{num_cand:"U2FsdGVkX19nrlT/WO2fE5QT8d6B5/RAus79GiiEBQU=",cpf:"U2FsdGVkX189VdAFH/YshFSemjXp3l7Urp+kGRKIgbw="},
{num_cand:"U2FsdGVkX1/CCP1coP1BEsEWRzgsj8q0tJlhTBfUQaE=",cpf:"U2FsdGVkX18gNxavHRrqam8c8u+jv6ELLt6Uy0de3Tw="},
{num_cand:"U2FsdGVkX1/uZBmf0OEs/klNhm5+CbZk2knQ0dGlEX0=",cpf:"U2FsdGVkX1+rNyMIQB3sy9wmbPCgVWgj5eH9O7X8NqI="},
{num_cand:"U2FsdGVkX18CiRZr6UmGQw9bHw+O3DBwzCIVyUreSYw=",cpf:"U2FsdGVkX1/c99i0dlTLHinoKV6T2rZGsLB3OTWyTNc="},
{num_cand:"U2FsdGVkX1/Q449flxfp7wpa7NN1ByzQrMXIKMsZzRM=",cpf:"U2FsdGVkX198KzKQF3YU+OKXETdnVHWnGhETfPkBMoY="},
{num_cand:"U2FsdGVkX188wXN3aqx+9AFOeThPhXXDk/MQEyWBwQY=",cpf:"U2FsdGVkX1/iPF7ajnbI7jYBNlycfZbmmFXfaY4i764="},
{num_cand:"U2FsdGVkX1/MxNiet7gGiKW11uZdJOvdMVHo+mnjHrs=",cpf:"U2FsdGVkX1/BIg8f1/uTbB2hZBLz8ZnqcC5RUCu4/bY="},
{num_cand:"U2FsdGVkX19tRESnn41BUJp92519y2v12KDVeqcULk8=",cpf:"U2FsdGVkX1+mGfQRA9VHTiKB3u4x0bSNrcDBclYkB54="},
{num_cand:"U2FsdGVkX1/N+rZ3f65T9UCb0heKYsVg9fWHE5IFoqc=",cpf:"U2FsdGVkX1/Ivsi15moek8PVCrA29jYj2+2HO25sNcs="},
{num_cand:"U2FsdGVkX1+Q80BvhWB/X7l4vyel8fFMCQoMX/8CZKU=",cpf:"U2FsdGVkX18kmkOxa+wxobWaK0CCX1qTPnN3b3pzkew="},
{num_cand:"U2FsdGVkX18FZcSPqevvxZIWKHjhDD7osriuLiQJceA=",cpf:"U2FsdGVkX1/Z4X5YVevQKoaqY3xEL3AvhIkaIHv9O6M="},
{num_cand:"U2FsdGVkX19bVeMvqZB48UETUjkfuulnXb9GqMZZYa4=",cpf:"U2FsdGVkX19vZWGQGRdfgZiwJTsqCoLHJLHf5awYP58="},
{num_cand:"U2FsdGVkX18ORrzkUna9XYKi7Kbu+sgBs3rayBBwId8=",cpf:"U2FsdGVkX1/7MaSIVBu1bRbAcv9K9tvI1giLvNtkawg="},
{num_cand:"U2FsdGVkX19sE81DylmA/Nj0eU2gL8oIrBOAuUUh/1E=",cpf:"U2FsdGVkX19SwKBc5cBV9Y3WBk6UA2lb/yef/OM2YC4="},
{num_cand:"U2FsdGVkX1+f+G9wmZFbvtYyaOz+d5KhL5m0V2s3igI=",cpf:"U2FsdGVkX1/e0ixtO9VftebMdJBJcAOZaUXWGW8FsXc="},
{num_cand:"U2FsdGVkX182+z90VP7Uq/XXderuIeKv5rXWVULzbNA=",cpf:"U2FsdGVkX1+c7mIhTzcXCUOyK7ZiHe+vmYNfvs7n910="},
{num_cand:"U2FsdGVkX1+wgvkvjBCVtv0Vx8JHr380uoVjxdOEX9M=",cpf:"U2FsdGVkX1/jmQMbl7x2xVxWyz4x96Zrn7AueoIOc3U="},
{num_cand:"U2FsdGVkX199ON/eFTrHiFTvUmZ+eNdynsCkUcqcAzA=",cpf:"U2FsdGVkX18AAbg2gT51yTyN+6CbqQ44xI6/FdYse1c="},
{num_cand:"U2FsdGVkX1+fos+75xSL8rXVLHx1COEqFLkHYZ8AU0U=",cpf:"U2FsdGVkX194gKhXysEiC4Kx5oDXeBORBuCe6t3Ev5s="},
{num_cand:"U2FsdGVkX181hzDBeNvWFnc87vNUepQeaYiyeL7SQ7M=",cpf:"U2FsdGVkX18W4tY1fgocxhTwDVKYlI9Gbam2kQ3Apk0="},
{num_cand:"U2FsdGVkX1+cGMPyOZNS6fImmzj6bz5MTjrM7cUpliY=",cpf:"U2FsdGVkX1+DMUkudn+Vh6wcNL/a4yZEjk9MqhxBDfE="},
{num_cand:"U2FsdGVkX18fbmGVmCJYd+I4MLNCTJf3Owbf5Vr+EQg=",cpf:"U2FsdGVkX1/WVlHMDjEDtp0l4SsMa6O+HVJdjshzo/E="},
{num_cand:"U2FsdGVkX1+Chk9WstRJyQU2jBR1rpzPJIGgHHMOj1E=",cpf:"U2FsdGVkX1+iFQXigyBKPI/QjZlMJbdAxQPVDGViFk0="},
{num_cand:"U2FsdGVkX1+JmX+zVopwX4y2BQ4hT4jXKdDg/1k+SBo=",cpf:"U2FsdGVkX18KhII4LKlEZZzscCm40a2DMJoE819dicE="},
{num_cand:"U2FsdGVkX1/1ANBy+uW7+5ByDiGOSx2EUn5cQacmc6c=",cpf:"U2FsdGVkX1+w8TMNkR+kFGxvisQV5/pPpMVr9ZX4LBY="},
{num_cand:"U2FsdGVkX19GQr5JWE4mnftC0ZT5Nnt05NWKH1UA5SA=",cpf:"U2FsdGVkX191XeQJos3djXBJrh9BMizH/MGF4/k2C1c="},
{num_cand:"U2FsdGVkX1+UdfzLnAJdDbXqbyNflPH9F8lXEUUKx8A=",cpf:"U2FsdGVkX188PsU92Gti4ptXuNLrHo0TnckaKCrLPKk="},
{num_cand:"U2FsdGVkX18b6XX2xpfwQ0yN9RuxayCD7r4TFOyac7A=",cpf:"U2FsdGVkX1/zfWknRaxrDxylYNyKLW7IEUWdHuNQaN0="},
{num_cand:"U2FsdGVkX19Yvl/bFFVAWRVv61oOTtD9oZoL8pCm76s=",cpf:"U2FsdGVkX1+iwQMnjnN0L0fbzz1vR1H/5n1sphsAr94="},
{num_cand:"U2FsdGVkX19TBDzRYGb74xwlyT+onHQLe/C5bnN+h9c=",cpf:"U2FsdGVkX1/SUBJjbhmMD0MHLJc5Z5NAuSt3ovcRzKc="},
{num_cand:"U2FsdGVkX18//Ip6jcV7w64M4MaDHx1/w3248k5lVcw=",cpf:"U2FsdGVkX1+ZzdAysuQOq5S+W/knZDC1zN6OzhzS6Dc="},
{num_cand:"U2FsdGVkX1+c9mRiYtKMJ9kqBQxjTdUdpXcZcRjr0C8=",cpf:"U2FsdGVkX19BXy6zrwNI2JRHo3q7uPETSPbZbYeFr/4="},
{num_cand:"U2FsdGVkX1/u5Np4ZP2cEd3vhb852BDWu8zdToobUJE=",cpf:"U2FsdGVkX18ZyqgWsfnPwLdnKwD7pl1hV6lBbo7KkB8="},
{num_cand:"U2FsdGVkX1/7sBUTTRcdU1WFcfIpyGr3kD65gs7G3go=",cpf:"U2FsdGVkX1+uOn0n8uSFKiEhkvEx+vb+t1xAhSegITM="},
{num_cand:"U2FsdGVkX1/hLNMbX4Wwyxrh3jyieaBlJIsqAByHT2c=",cpf:"U2FsdGVkX18fzK47PY+ZX8BcCAkRYOthq/rFk4EbDqM="},
{num_cand:"U2FsdGVkX1/1epl+BxmPXKAoRPfPA3K6ZlMVDYGN9yU=",cpf:"U2FsdGVkX19jZQg1u8aF5Z3ou5n1BwPkVIsBjCFJ7ns="},
{num_cand:"U2FsdGVkX1/T/sgbtQOfup+mKfkfJzSKoZOn2M23mc4=",cpf:"U2FsdGVkX19vkkODxrTYsgh7mrWxuSrY4daUzNwDdf0="},]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/${concurso.substring(0,4)}/${concurso}/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
